import ConfirmationActions from 'actions/ConfirmationActions.js';

// One time off entry as the schedule page and the self-schedule page both render it: the calendar
// chip and the sidebar row resolve an unavailable the same way.

// A block N/A entry arrives with its type on the row; a month overlay row names it by id, and the
// store's type list covers only the month last fetched.
const typeOf = item => (
  item.unavailable_type || UnavailablesStore.getUnavailableTypesById(item.unavailable_type_id)
);

// The props UnavailableSidebarItem takes for one unavailable, resolved against its request and
// type in UnavailablesStore.
export function describeUnavailable(item, t) {
  const request = UnavailablesStore.getAllUnavailableRequestsById(item.unavailable_request_id);
  const type = typeOf(item);
  const zone = Utils.getCoreUser().inferred_time_zone;
  const hours = time => (time == null ? '' : moment(time).tz(zone).format('h:mm a'));

  let startDate;
  let endDate;
  if (request) {
    startDate = request.start_date;
    endDate = request.end_date;
  } else {
    // https://github.com/AppColony/makeshift/issues/5718: a partial entry whose UTC start and end
    // fall on different days takes its own timestamps rather than its date.
    const utcStart = moment.utc(item.starts_at);
    const utcEnd = moment.utc(item.ends_at);
    const spansUtcMidnight = item.partial && utcEnd.isSame(utcStart.add(1, 'days'), 'd');
    startDate = spansUtcMidnight ? item.starts_at : item.date;
    endDate = spansUtcMidnight ? item.ends_at : item.date;
  }

  const requestState = request ? request.state : undefined;
  const state = typeof item.state !== 'undefined' ? item.state : requestState;

  return {
    id: item.id,
    requestId: item.unavailable_request_id,
    typeName: type ? type.name : '',
    startDate: Utils.formatLocaleDate(moment(startDate)),
    endDate: Utils.formatLocaleDate(moment(endDate)),
    hoursRange: item.partial ? `${hours(item.starts_at)} - ${hours(item.ends_at)}` : '',
    // null from the JSON:API row reads as no note, like the absent key of the flat one.
    notes: item.notes != null ? item.notes : ((request && request.notes) || ''),
    state,
    displayedState: t(state === 'new' ? 'SidebarTimeOff.pending' : 'SidebarTimeOff.approved'),
    source: item.source,
    na: !!item.na,
    colour: item.colour,
  };
}

// The calendar chip for one unavailable, as both calendars draw it. A partial entry reads as its
// hours in the employee's zone, an N/A day as its type's name in the type's colour, and anything
// else as Time Off.
export function describeUnavailableChip(item, t) {
  const zone = Utils.getCoreUser().inferred_time_zone;
  const hours = time => Utils.formatTimeString(moment(time).tz(zone).format('h:mm a'));
  const type = typeOf(item);

  let label = t('ScheduleDay.time_off');
  if (item.partial) {
    label = `${hours(item.starts_at)} – ${hours(item.ends_at)}`;
  } else if (item.na && type) {
    label = type.name;
  }

  return {
    type: item.na ? 'timeoff na' : 'timeoff',
    na: !!item.na,
    colour: item.colour,
    label,
  };
}

// Removing an N/A day from its row: the app's confirmation modal with the N/A copy, then
// `remove`, whichever path the caller removes through.
export function confirmRemoveNa(t, remove) {
  ConfirmationActions.confirm({
    header: t('na.staff.self_remove.confirm_title'),
    body: t('na.staff.self_remove.confirm_body'),
    confirmation_cb: remove,
  });
}
